import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ErrorNavSection } from './error-nav.models';

import { Accordion, AccordionPanel, AccordionHeader, AccordionContent } from 'primeng/accordion';
import { Ripple } from 'primeng/ripple';

@Component({
  selector: 'cmg-clear2-ui-error-nav',
  templateUrl: './error-nav.component.html',
  styleUrl: './error-nav.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Accordion, AccordionPanel, Ripple, AccordionHeader, AccordionContent],
})
export class ErrorNavComponent {
  @Input() errors: ErrorNavSection[];

  isOpen = true;

  toggleOpen(): void {
    this.isOpen = !this.isOpen;
  }

  goToControl(controlId: string): void {
    const htmlCtrl = document.getElementById(controlId);
    if (htmlCtrl) {
      htmlCtrl.tabIndex = 0;
      // If scrollTo does not work, check whether the element has a tabindex defined. For some reason that seems to be necessary.
      // scrollIntoView has issues in Chrome when setting behavior to smooth so leave it set to auto for now
      htmlCtrl.scrollIntoView({ behavior: 'auto', block: 'center', inline: 'end' });
      htmlCtrl.classList.add('validation-glow');

      setTimeout(() => {
        htmlCtrl.classList.remove('validation-glow');
      }, 6000);

      setTimeout(
        (ctrl: HTMLElement) => {
          ctrl.focus();
          htmlCtrl.tabIndex = undefined;
        },
        100 /* 100 ms seems to work always */,
        htmlCtrl,
      );
    }
  }
}
